module.exports = __webpack_public_path__ + "static/img/02-07.98d63904.png";